<template>
  <i class="fa fa-fw fa-whatsapp"></i>
</template>

<script>
export default {
  name: 'Whatsapp',
};
</script>

<style scoped>
.fa-whatsapp {
  color: #0fa251;
}
</style>



// WEBPACK FOOTER //
// WhatsappIcon.vue?c320cc32